export default __webpack_public_path__ + "1ed2fe0ebbdb5183dc679ebefc580d16.svg";